import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  listAttendees: [],
  error: null,
  checkInAttendeeSuccess: false,
  reservation: null
}

const slice = createSlice({
  name: 'listAttendees',
  initialState: initialState,
  reducers: {
    getReservationAction: (state, action) => {
      state.loading = true
      state.error = null
    },
    setReservationAction:(state, action)=>{
      state.loading = false
      state.error = null
      state.reservation = action.payload
    },
    getListAttendeesAction: (state, action) => {
      state.loading = true
      state.error = null
    },
    setListAttendeesAction:(state, action)=>{
      state.loading = false
      state.listAttendees = action.payload
      state.error = null
    },
    checkInAttendeeAction: (state, action) => {
      state.loading = true
      state.error = null
    },
    checkInAttendeeSuccessAction:(state,action)=>{
      state.loading = false
      state.checkInAttendeeSuccess = action.payload
      state.error = null
    },
    checkInAttendeeErrorAction: (state, action) => {
      state.loading = false
      state.checkInAttendeeSuccess = false
      state.error = action.payload
    },
    errorListAttendeesAction: (state, action) => {
      state.loading = false
      state.error = action.payload
      state.listAttendees = []
    },
    listAttendeesResetState: () => initialState,
  },
});

export const {
  getListAttendeesAction,
  setListAttendeesAction,
  errorListAttendeesAction,
  listAttendeesResetState,
  checkInAttendeeAction,
  checkInAttendeeSuccessAction,
  checkInAttendeeErrorAction,
  getReservationAction,
  setReservationAction,
} = slice.actions

export default slice.reducer
